module.exports = __webpack_public_path__ + "img/user-1-banner.08647f6e.jpeg";